import insertParams from 'utils/insertParams';
import ProductsPageRoute from 'apps/productsPages/utils/ProductsPageRoute';
import { slugifyParam } from 'utils/url';
import { isRegularProduct } from './utils/skuType';

function mapBasePathToFromParameter(basePath) {
  switch (basePath) {
    case '/search': return 'search';
    case '/browse': return 'shop';
    case '/on-offer': return 'offers';
    case '/offers': return 'offer_details';
    case '/your-savings-hub': return 'your_savings_hub';
    case 'trolley': return 'trolley'; // fake route
    case 'recommended_items': return 'recommended_items'; // fake route
    default: return 'shop';
  }
}

// this function creates a URL parameters string allowing old webshop bop page to render breadcrumbs properly
// (by passing ex. "tags" and "from" parameters) it should be removed as soon as the new raven bop is introduced
// as we do not want to pass navigation details through URL parameters
function getWebshopUrlParameters(location, params) {
  const productsPageRoute = ((location && params)
    ? new ProductsPageRoute(location, params)
    : { deslugifiedQuery: {}, deslugifiedParams: {}, basePath: '' }
  );

  const { deslugifiedQuery, deslugifiedParams, basePath } = productsPageRoute;

  const urlParameters = {
    from: mapBasePathToFromParameter(basePath),
  };

  if (deslugifiedParams.tags) {
    urlParameters.tags = deslugifiedParams.tags.join('%7C');
  }

  if (deslugifiedParams.id) {
    urlParameters.param = deslugifiedParams.id;
  }

  if (deslugifiedQuery.entry) {
    urlParameters.param = encodeURIComponent(deslugifiedQuery.entry);
    urlParameters.from = 'search';
  }

  return urlParameters;
}

export function getProductDetailsLink({ product, location, params, betaFeatures = [] }) {
  const productCanonicalName = product.name.replace(/\W+/g, '-').replace(/(^-+|-+$)/g, '');

  if (betaFeatures.includes('RAVEN_BOP') &&
    (isRegularProduct(product) ||
    (!isRegularProduct(product) && betaFeatures.includes('RAVEN_BOP_25776_DERIVATIVES')))) {
    return `/products/${productCanonicalName.toLowerCase()}-${product.sku}`;
  }

  let productDetailsLink;
  if (product.name) {
    productDetailsLink = `/webshop/product/${productCanonicalName}/${product.sku}`;
  } else {
    productDetailsLink = `/webshop/getProductDetails.do?sku=${product.sku}`;
  }
  const webshopUrlParameters = getWebshopUrlParameters(location, params);
  return insertParams(productDetailsLink, webshopUrlParameters);
}

// TODO while RAVEN_BOP betafeature is turned on to 100% refactor getProductDetailsLink and merge/substitute it with getEnforcedProductDetailsLink
export function getEnforcedProductDetailsLink(name, sku, queryParams) {
  return `/products/${slugifyParam(name, sku)}${queryParams}`;
}

export function getProductAlternativesLink(product) {
  return `/webshop/getAlternatives.do?sku=${product.sku}`;
}
